import { useMutation } from 'react-query';
import { userIP } from '../UserIP';

export const useUserIP = () => {
  return useMutation<{ ip: string }, unknown, void, unknown>(async () => {
    const { data } = await userIP.getUserIP();
    return data;
  });
};
